module.exports = __webpack_public_path__ + "img/e-quip-wh.e7d2cba2.svg";